module.exports = __webpack_public_path__ + "img/about-img.2e66d4ce.png";